/**
 * RouteCorridorForm - Reusable form component for creating/editing route corridors
 */

import React from "react";
import { Form, Input, Select, Button, Space, Switch } from "antd";
import { SaveOutlined, CloseOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const PROVINCES = [
  { value: "GP", label: "Gauteng" },
  { value: "WC", label: "Western Cape" },
  { value: "EC", label: "Eastern Cape" },
  { value: "KZN", label: "KwaZulu-Natal" },
  { value: "LP", label: "Limpopo" },
  { value: "MP", label: "Mpumalanga" },
  { value: "NW", label: "North West" },
  { value: "NC", label: "Northern Cape" },
  { value: "FS", label: "Free State" },
];

const RouteCorridorForm = ({
  form,
  onFinish,
  onCancel,
  loading = false,
  initialValues = {},
}) => {
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={{
        active: true,
        provinces: [],
        ...initialValues,
      }}
    >
      <Form.Item
        name="name"
        label="Route Corridor Name"
        rules={[
          { required: true, message: "Route corridor name is required" },
          {
            pattern: /^[A-Z0-9\-]+$/,
            message: "Name must contain only uppercase letters, numbers, and hyphens (e.g., WC-EC-KZN)",
          },
          { min: 2, message: "Name must be at least 2 characters" },
          { max: 50, message: "Name must be less than 50 characters" },
        ]}
        normalize={(value) => value?.toUpperCase().trim()}
      >
        <Input
          placeholder="e.g., WC-EC-KZN, GP-KZN"
          size="large"
          style={{ textTransform: "uppercase" }}
        />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"
        rules={[
          {
            max: 500,
            message: "Description must be less than 500 characters",
          },
        ]}
      >
        <TextArea
          placeholder="Enter route corridor description (optional)"
          rows={3}
          showCount
          maxLength={500}
        />
      </Form.Item>

      <Form.Item
        name="provinces"
        label="Provinces"
        rules={[
          {
            type: "array",
            min: 1,
            message: "Select at least one province",
          },
        ]}
      >
        <Select
          mode="multiple"
          placeholder="Select provinces for this route"
          size="large"
          showSearch
          optionFilterProp="label"
          options={PROVINCES.map((province) => ({
            value: province.value,
            label: `${province.label} (${province.value})`,
          }))}
        />
      </Form.Item>

      <Form.Item name="active" valuePropName="checked" label="Active">
        <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
      </Form.Item>

      <Form.Item>
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={onCancel} icon={<CloseOutlined />}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            icon={<SaveOutlined />}
          >
            {initialValues.id ? "Update" : "Create"} Route Corridor
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default RouteCorridorForm;

